import { render, staticRenderFns } from "./approvals_list.vue?vue&type=template&id=291677d0"
import script from "./approvals_list.vue?vue&type=script&lang=js"
export * from "./approvals_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports